<svg
  class="h-4 w-4"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="3"
    d="M5 13l4 4L19 7"
  />
</svg>
